module.exports = __webpack_public_path__ + "img/insurance-providers.584638f.png";